// extracted by mini-css-extract-plugin
export var emailBlockLink = "_iz-0";